/* eslint-disable no-console */
import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import isNil from "lodash/isNil";
import firebase from "firebase/app";

import Home from "./views/Home.vue";
import CheckLogin from "./views/Check/checkAuth.vue";

Vue.use(Router);

const login = () =>
    import ( /* webpackChunkName: "chunk-login" */ "./views/Account/login.vue");
const add = () =>
    import ( /* webpackChunkName: "chunk-login" */ "./views/add.vue");

const more = () =>
    import ( /* webpackChunkName: "chunk-login" */ "./views/more.vue");

const account = () =>
    import ( /* webpackChunkName: "chunk-login" */ "./views/Account/index.vue");

const faq = () =>
    import ( /* webpackChunkName: "chunk-fqa" */ "./views/settings/faq.vue");
const contact = () =>
    import ( /* webpackChunkName: "chunk-contact" */ "./views/settings/contact.vue");
const feedback = () =>
    import ( /* webpackChunkName: "chunk-feedback" */ "./views/settings/feedback.vue");
const share = () =>
    import ( /* webpackChunkName: "chunk-share" */ "./views/settings/share.vue");
const informations = () =>
    import ( /* webpackChunkName: "chunk-fqa" */ "./views/settings/informations/index.vue");
const userAccount = () =>
    import ( /* webpackChunkName: "chunk-fqa" */ "./views/settings/account/index.vue");


const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            path: "*",
            redirect: "/"
        },
        {
            path: "/",
            name: "home",
            component: Home,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: "/check-login",
            name: "check-login",
            component: CheckLogin,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: "/login",
            name: "login",
            component: login,
            beforeEnter: (to, from, next) => {
                const currentUser = firebase.auth().currentUser;
                if (currentUser) {
                    next({
                        path: "/"
                    });
                } else if (currentUser) {
                    next();
                } else {
                    next();
                }
            },
            meta: {
                requiresAuth: false
            }
        },
        {
            path: "/add",
            name: "add",
            component: add,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/more",
            name: "more",
            component: more,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/account/:id/account",
            name: "userAccount",
            component: userAccount,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/account/:id",
            name: "account",
            component: account,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: "/account/:id/faq",
            name: "faq",
            component: faq,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: "/account/:id/contact",
            name: "contact",
            component: contact,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: "/account/:id/share",
            name: "share",
            component: share,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: "/account/:id/feedback",
            name: "feedback",
            component: feedback,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: "/account/:id/informations",
            name: "informations",
            component: informations,
            meta: {
                requiresAuth: true
            },
        },
    ]
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
    const currentUser = isNil(store.state.user.userProfile);

    if (requiresAuth && currentUser) {
        const path =
            store.state.user.userProfile !== null ? "/login" : "/check-login";
        next(`${path}?redirectUrl=${to.path}`);
    } else {
        next();
    }
    next();
});

export default router;